import queryString from 'query-string';
import { getOriginalWindowSearch } from './QueryParams';

export const getUseComparePreview = () => {
  const val = queryString.parse(getOriginalWindowSearch()).useComparePreview;
  return val ? 'true' : 'false';
};
